<template>
    <div class="map-lazy-img">
        <div
            v-if="data_url"
            :style="{ background }"
            class="map-img-placeholder"
            >
            <img :src="placeholder || data_url" alt="" v-bind="$attrs" />
        </div>
        <img
            :src="data_url"
            :alt="$attrs.alt || ''"
            v-bind="$attrs"
            class="map-img-img"
        />
    </div>
</template>
<script>
    export default
    {
        inheritAttrs: false,
        name: 'lazy-img',
        props:
        {
            src:
            {
                type: String,
                required: true,
            },
            placeholder: String,
            background: String,
        },
        computed:
        {
            data_url()
            {
                const { width, height } = this.$attrs;

                if (!width || !height)
                {
                    return '';
                }

                const w = 100;
                const canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = (height / width) * w;

                return canvas.toDataURL();
            },
        },
        mounted()
        {
            const { src, srcset, $el } = this;

            const observer = new IntersectionObserver(([entry]) =>
            {
                const img = $el.querySelector('.map-img-img');
                const placeholder = $el.querySelector('.map-img-placeholder');

                img.onload = function()
                {
                    delete img.onload;
                    $el.classList.add('map-img-loaded');

                    if (placeholder)
                    {
                        setTimeout(() =>
                        {
                            placeholder.remove();
                        }, 300);
                    }
                };

                img.onerror = () =>
                {
                };

                if (entry.isIntersecting)
                {
                    // Element is in viewport
                    if (srcset)
                    {
                        img.srcset = srcset;
                    }

                    img.src = src;
                    observer.disconnect();
                }
            });

            observer.observe($el);

            // this.$once("hook:beforeDestroy", () =>
            // {
            //     observer.disconnect();
            //
            //     if (time_out)
            //     {
            //         clearTimeout(time_out);
            //     }
            // });
        },
    }
</script>

<style>
.map-img
{
    display: inline-block;
    position: relative;
}

.map-img-placeholder
{
    position: absolute;
    overflow: hidden;
}

.map-img-placeholder img
{
    transform: scale(1.05);
    filter: blur(10px);
}

.map-img-img
{
    opacity: 0;
    transition: opacity 300ms ease;
}

.map-img-loaded .map-img-img
{
    opacity: 1;
}
</style>
